<template>
  <div class="docBox">
    <div class="menu-title">简古香铺管理平台-商品api接口操作手册</div>
    <p class="red">后台登录网址： http://49.235.101.120:3000 </p>
    <p class="red">
    登录后获取token，在请求头中添加Authorization: Bearer token
    </p>
    <p class="red">
      API仅用于合作客户数据获取，禁止分享第三方使用，平台将追究其相应法律责任。
    </p>

    <div class="menu">
      <ul>
        <li><a href="#quick=start">商品分类查询</a></li>
        <li><a href="#create-activity">商品列表查询</a></li>
        <li><a href="#host-info">商品图片查询</a></li>
      </ul>
    </div>

    <h1 id="quick-start">商品分类查询</h1>
    <p>
      请求方式：POST
    </p>
    <p>
      http://192.168.0.124:6688/public/goods/selectCategory
    </p>
    <p class="red">
     请求参数说明： 
     categoryName -分类名称,
    categoryLevel -级别,
    parentID -父级id,
    status -分类状态
    </p>
    <p class="red">
      返回参数格式：
    </p>
    <pre class="pre-text">
{
	"data": [
		{
			"id": 22,
			"categoryName": "家庭用品",
			"categoryLevel": 1,
			"parentID": null,
			"status": 0,
			"message": null,
			"img_head": "https://huiyouxuan-1347759482.cos.ap-guangzhou.myqcloud.com/mall%2F11751641187.png",
			"sort": 1
		},
		{
			"id": 21,
			"categoryName": "日用品",
			"categoryLevel": 2,
			"parentID": 22,
			"status": 0,
			"message": "日用品日用品日用品日用品",
			"img_head": "https://huiyouxuan-1347759482.cos.ap-guangzhou.myqcloud.com/mall%2F11751641187.png",
			"sort": 0
		},
		{
			"id": 23,
			"categoryName": "厨房用品",
			"categoryLevel": 2,
			"parentID": 22,
			"status": 0,
			"message": null,
			"img_head": "https://huiyouxuan-1347759482.cos.ap-guangzhou.myqcloud.com/mall%2F11751641187.png",
			"sort": 0
		},
		{
			"id": 24,
			"categoryName": "食品",
			"categoryLevel": 1,
			"parentID": null,
			"status": 0,
			"message": null,
			"img_head": "https://huiyouxuan-1347759482.cos.ap-guangzhou.myqcloud.com/mall%2F11751641187.png",
			"sort": 0
		},
		{
			"id": 25,
			"categoryName": "水果",
			"categoryLevel": 2,
			"parentID": 24,
			"status": 0,
			"message": null,
			"img_head": "https://huiyouxuan-1347759482.cos.ap-guangzhou.myqcloud.com/mall%2F11751641187.png",
			"sort": 0
		}
	],
	"code": 200,
	"msg": "操作成功"
}
    </pre>

    <h1 id="create-activity">商品列表查询</h1>
    <p>
      请求方式：POST
    </p>
    <p>
      http://192.168.0.124:6688/public/goods/select
    </p>
    <p class="red">
     请求参数说明：    
     productCategory -分类id,
    productName  -商品名模糊查询,
    pageNumber -页码,
    pageSize -每页条数
    </p>
    <p class="red">
      返回参数格式：
    </p>
      <pre class="pre-text">
{
	"data": [
		{
			"id": 1089,
			"type": 2,
			"store_id": 111111,
			"productCategory": 21,
			"productName": "都乐（Dole） 超甜蕉 1把 1.4kg",
			"productCode": "10010",
			"coverImg": "https://huiyouxuan-1347759482.cos.ap-guangzhou.myqcloud.com/mall/95977466436.jpg",
			"videoLink": null,
			"status": 3,
			"stockNum": "0",
			"num": null,
			"introduce": "产地优越 新鲜采摘 软糯可口 皮薄肉甜",
			"price": null,
			"price": "19.9",
			"isSku": 0,
			"exchangeType": null,
			"couponAmount": null,
			"createTime": "2025-03-20 07:47:14"
		},
		{
			"id": 1088,
			"type": 2,
			"store_id": 111111,
			"productCategory": 21,
			"productName": "Member's Mark 经典压花纸面巾",
			"productCode": "444",
			"coverImg": "https://huiyouxuan-1347759482.cos.ap-guangzhou.myqcloud.com/mall/93856205781.jpg",
			"videoLink": null,
			"status": 0,
			"stockNum": "0",
			"num": null,
			"introduce": "柔软如棉 细致花纹 亲肤湿水不易破",
			"price": "333",
			"price": "222",
			"isSku": 1,
			"exchangeType": null,
			"couponAmount": null,
			"createTime": "2025-03-19 23:58:18"
		}
	],
	"code": 200,
	"msg": "操作成功",
	"count": 2
}
      </pre>

    <h1 id="ticket-price">商品图片查询</h1>
    <p>
      请求方式：POST
    </p>
    <p>http://192.168.0.124:6688/public/goods/selectImg</p>
    <p class="red">
      请求参数说明：
      productId -商品id,
      imgType -类型：1轮播图 2详情图
    </p>
    <p class="red">
      返回参数格式：
    </p>
    <pre class="pre-text">
    {
	"data": [
		{
			"id": 9262,
			"productId": 1088,
			"imgUrl": "https://huiyouxuan-1347759482.cos.ap-guangzhou.myqcloud.com/mall/25704403385.jpg",
			"imgType": 1,
			"createTime": "2025-03-19 21:44:29",
			"sort": 0
		},
		{
			"id": 9263,
			"productId": 1088,
			"imgUrl": "https://huiyouxuan-1347759482.cos.ap-guangzhou.myqcloud.com/mall/36605310411.jpg",
			"imgType": 1,
			"createTime": "2025-03-19 21:51:05",
			"sort": 1
		},
		{
			"id": 9261,
			"productId": 1088,
			"imgUrl": "https://huiyouxuan-1347759482.cos.ap-guangzhou.myqcloud.com/mall/68968025042.jpg",
			"imgType": 1,
			"createTime": "2025-03-19 21:51:44",
			"sort": 2
		}
	],
	"code": 200,
	"msg": "操作成功"
}
</pre>
    <h1 id="kefu">其他问题</h1>
    <p>
      如有其他问题，请联系客服及时为您解答。
    </p>


    <!-- Back to Top Button -->
    <!-- <button class="back-to-top" @click="scrollToTop">↑</button> -->
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};
</script>

<style scoped>
.docBox {
  max-width: 80%;
  margin: 30px 20px;
  color: #313238;
  letter-spacing: 1.5px;
  padding: 0 5% 20% 5%;
}

.menu {
  background-color: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.menu-title {
  font-size: 1.5em;
  margin-bottom: 10px;
  font-weight: 600;
  text-align: center;
}

h1 {
  font-size: 1.5em;
  margin-top: 2em;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  margin: 10px 0;
  display: block;
}

a {
  text-decoration: none;
  color: #8c8c8c;
  font-weight: bold;
  transition: color 0.3s, border-bottom-color 0.3s;
  border-bottom: 2px solid transparent;
  padding: 10px;
  display: block;
  transition: 0.5s;
}

a:hover {
  color: #fff;
  background: #adb68d;
}

p {
  margin: 10px 0;
  padding: 10px;
  font-size: 1em;
  line-height: 1.6;
  background-color: #f8f9fa;
  border-left: 4px solid #adb68d;
  border-radius: 4px;
}

img {
  margin: 10px;
  padding: 10px;
  max-height: 40vh;
  max-width: 90vw;
  object-fit: contain;
  border-radius: 10px;
  box-shadow: #ebebeb 1px 1px 10px;
}

.red {
  border-left: 5px solid #ff0000;
  color: #d95656;
}

.ImgBox {
  display: flex;
  flex-direction: row;
  overflow: auto;
  padding-bottom: 15px;
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: #ccd0b6;
  border-radius: 10px;
  border: 2px solid transparent;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #afb68d;
}

.back-to-top {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: #adb68d;
  color: white;
  border: none;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  font-size: 1.5em;
  cursor: pointer;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  transition: background-color 0.3s;
}

.back-to-top:hover {
  background-color: #8c8c8c;
}


.pre-text {
  background-color: #f8f9fa;
  padding: 10px;
}
</style>
